import React, { useState, Fragment, useEffect } from "react";
import "./signup.css";
import FormButton from "./FormNextButton";
import { useDispatch, useSelector } from "react-redux";
import {
  changeButton,
  nextStepFuncFirstForm,
  handleSteps,
} from "../../redux-toolkit/reducer/accountCreationApiReducer";
import PrivacyAndPolicy from "./PrivacyAndPolicy";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Checkbox from "@mui/material/Checkbox";
import Select from "react-select";
import { securityQuestions } from "../../constants/constants";
import { Controller, useForm } from "react-hook-form";
import { fetchUserIpData } from "../../redux-toolkit/reducer/websitePlan";
import zIndex from "@mui/material/styles/zIndex";

export default function StepOneOwnerDetails() {
  const { userIpData } = useSelector((state) => state.websitePlans);
  useEffect(() => {
    dispatch(fetchUserIpData());
  }, []);
  const { stepNo, step } = useSelector(
    (state) => state.accountCreationApiReducer
  );

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    clearErrors,
    control,
  } = useForm();

  // ==========================  Phone Number Input Library COde  =============== //
  const [countryCode, setcuntrycode] = useState("");
  const [isDialCode, setDialCode] = useState("");
  const [mobileNo, setmobileNo] = useState("");
  function phoneInput(value, data) {
    setmobileNo(value);
    setDialCode(data.dialCode);
    setcuntrycode(`${data.countryCode}`);
    if (customErr !== "") setCustomErr("");
  }

  const dispatch = useDispatch();

  const [question, setQuestion] = useState("");
  const [customErr, setCustomErr] = useState("");

  useEffect(() => {}, []);

  const isFormValidCheck = (postdata) => {
    const validationObj = countryPhoneValidationArr[countryCode];
    console.log(mobileNo, validationObj, "validationObj");
    const isvalideNumber = validatePhoneNumberLength(validationObj, mobileNo);
    if (!isvalideNumber) {
      return;
    }

    let data = {
      email: postdata.email.toLowerCase(),
      password: postdata.password,
      firstName: postdata.firstName,
      lastName: postdata.lastName,
      mobileNo: mobileNo,
      privacyPolicy: postdata.privacy,
      security_questions: {
        question: postdata.question?.value,
        answer: postdata.securityAnswer,
      },
    };
    dispatch(nextStepFuncFirstForm(data));
    nextStepChangeHandler();
  };

  function nextStepChangeHandler() {
    dispatch(
      changeButton({
        currentNo: stepNo,
        buttonText: "Next",
        stepNo: stepNo + 1,
        nextNo: stepNo + 1,
      })
    );
    dispatch(handleSteps({ errorMsg: "", registerSuccess: 0 }));
  }

  function selectQuestion(event) {
    setQuestion(event.label);
    setCustomErr("");
  }

  return (
    <Fragment>
      <div
        className="col-md-4 form_box"
        style={{ display: `${step === "step1" ? "block" : "none"}` }}
      >
        <form>
          <h4>Create Account</h4>
          <div className="mb-2">
            <input
              type="email"
              id="email"
              className="form-control"
              {...register("email", {
                required: true,
                pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              })}
              placeholder="Email"
            />
            {errors?.email?.type === "required" && (
              <p className="error_style error_bottom">This field is required</p>
            )}
            {errors?.email?.type === "pattern" && (
              <p className="error_style error_bottom">Invalid email address</p>
            )}
          </div>

          <div className="mb-2">
            <input
              type="password"
              id="password"
              className="form-control"
              {...register("password", {
                required: true,
              })}
              placeholder="Password"
            />
            {errors?.password?.type === "required" && (
              <p className="error_style error_bottom">This field is required</p>
            )}
          </div>

          <div className="mb-3">
            <Controller
              control={control}
              name="question"
              rules={{
                required: "Security question is required",
              }}
              render={({ field }) => {
                return (
                  <Select
                    {...field}
                    isClearable
                    isSearchable={false}
                    className="react-dropdown"
                    classNamePrefix="dropdown"
                    options={securityQuestions}
                  />
                );
              }}
            />
            <p className="error_style">
              {errors.question?.message || errors.question?.label.message}
            </p>
            {/* <Select
              className="select_Box_border"
              placeholder="Security Question"
              options={securityQuestions}
              onChange={selectQuestion}
              required={true}
            />
            {customErr === "question" && (
              <p className="error_style">This field is required</p>
            )} */}
          </div>

          {watch("question", "")?.value !== "" && (
            <div className="mb-2">
              <input
                type="text"
                id="securityAnswer"
                className="form-control"
                {...register("securityAnswer", {
                  required: true,
                })}
                placeholder="Security Answer"
              />
              {errors?.securityAnswer?.type === "required" && (
                <p className="error_style error_bottom">
                  This field is required
                </p>
              )}
            </div>
          )}

          <div className="mb-2">
            <input
              type="text"
              style={{ marginTop: "20px" }}
              id="firstName"
              className="form-control"
              {...register("firstName", {
                required: true,
              })}
              placeholder="First Name"
            />
            {errors?.firstName?.type === "required" && (
              <p className="error_style error_bottom">This field is required</p>
            )}
          </div>

          <div className="mb-2">
            <input
              type="text"
              id="lastName"
              className="form-control"
              {...register("lastName", {
                required: true,
              })}
              placeholder="Last Name"
            />
            {errors?.lastName?.type === "required" && (
              <p className="error_style error_bottom">This field is required</p>
            )}
          </div>

          <div className="col-md-12 form-group">
            <div className="position-relative">
              <PhoneInput
                country={
                  userIpData?.country ? userIpData?.country?.toLowerCase() : ""
                }
                inputProps={{
                  name: "phone",
                  required: true,
                }}
                isValid={(value, country) => {
                  const validationObj = countryPhoneValidationArr[country.iso2];
                  const isvalideNumber = validatePhoneNumberLength(
                    validationObj,
                    value
                  );
                  return isvalideNumber || "Invalid phone number";
                }}
                onChange={phoneInput}
              />
            </div>
          </div>
          <div className="checkbox-wrapper row">
            <div className="col-2" style={{ maxWidth: "50px" }}>
              <Checkbox
                name="privacy"
                className="align-items-start"
                {...register("privacy", {
                  required: true,
                })}
                inputProps={{ "aria-label": "controlled" }}
              />
            </div>
            <div className="col-10">
              <PrivacyAndPolicy />
            </div>
          </div>
          {errors?.privacy?.type === "required" && (
            <p className="error_style privacy_error">
              Please check the Privacy policy and Terms and Conditions.
            </p>
          )}
          <FormButton isFormValidCheck={handleSubmit(isFormValidCheck)} />
          {/* <LoginRedirection /> */}
        </form>
      </div>
    </Fragment>
  );
}

function validatePhoneNumberLength(countryInfo, phoneNumber) {
  if (!countryInfo) {
    return true;
  }

  const minusCodeLength = countryInfo?.code?.length - 1;
  const inputLength =
    String(phoneNumber).replace(/\D/g, "").length - minusCodeLength; // digits only
  // Handle lengths as either number or array
  const allowedLengths = Array.isArray(countryInfo.lengths)
    ? countryInfo.lengths
    : [countryInfo.lengths];
  // Check match
  return allowedLengths.includes(inputLength);
}

function transformCountriesToObject(countryArray) {
  const result = {};

  countryArray.forEach(({ code, label, phone, phoneLength }) => {
    result[code.toLowerCase()] = {
      country: label,
      code: `+${phone.replace(/\D/g, "")}`, // clean country code
      lengths: phoneLength,
    };
  });

  return result;
}

const countryPhoneValidationArr = {
  ad: {
    country: "Andorra",
    code: "+376",
    lengths: 6,
  },
  ae: {
    country: "United Arab Emirates",
    code: "+971",
    lengths: 9,
  },
  af: {
    country: "Afghanistan",
    code: "+93",
    lengths: 9,
  },
  ag: {
    country: "Antigua and Barbuda",
    code: "+1268",
    lengths: 10,
  },
  ai: {
    country: "Anguilla",
    code: "+1264",
    lengths: 10,
  },
  al: {
    country: "Albania",
    code: "+355",
    lengths: 9,
  },
  am: {
    country: "Armenia",
    code: "+374",
    lengths: 6,
  },
  ao: {
    country: "Angola",
    code: "+244",
    lengths: 9,
  },
  aq: {
    country: "Antarctica",
    code: "+672",
    lengths: 6,
  },
  ar: {
    country: "Argentina",
    code: "+54",
    lengths: [6, 7, 8],
  },
  as: {
    country: "American Samoa",
    code: "+1684",
    lengths: 10,
  },
  at: {
    country: "Austria",
    code: "+43",
    lengths: [10, 11],
  },
  au: {
    country: "Australia",
    code: "+61",
    lengths: 9,
  },
  aw: {
    country: "Aruba",
    code: "+297",
    lengths: 7,
  },
  ax: {
    country: "Alland Islands",
    code: "+358",
  },
  az: {
    country: "Azerbaijan",
    code: "+994",
    lengths: 9,
  },
  ba: {
    country: "Bosnia and Herzegovina",
    code: "+387",
    lengths: 8,
  },
  bb: {
    country: "Barbados",
    code: "+1246",
    lengths: 10,
  },
  bd: {
    country: "Bangladesh",
    code: "+880",
    lengths: 10,
  },
  be: {
    country: "Belgium",
    code: "+32",
    lengths: 9,
  },
  bf: {
    country: "Burkina Faso",
    code: "+226",
    lengths: 8,
  },
  bg: {
    country: "Bulgaria",
    code: "+359",
    lengths: 9,
  },
  bh: {
    country: "Bahrain",
    code: "+973",
    lengths: 8,
  },
  bi: {
    country: "Burundi",
    code: "+257",
    lengths: 8,
  },
  bj: {
    country: "Benin",
    code: "+229",
    lengths: 8,
  },
  bl: {
    country: "Saint Barthelemy",
    code: "+590",
    lengths: 9,
  },
  bm: {
    country: "Bermuda",
    code: "+1441",
    lengths: 10,
  },
  bn: {
    country: "Brunei Darussalam",
    code: "+673",
    lengths: 7,
  },
  bo: {
    country: "Bolivia",
    code: "+591",
    lengths: 9,
  },
  br: {
    country: "Brazil",
    code: "+55",
    lengths: 11,
  },
  bs: {
    country: "Bahamas",
    code: "+1242",
    lengths: 10,
  },
  bt: {
    country: "Bhutan",
    code: "+975",
    lengths: 7,
  },
  bv: {
    country: "Bouvet Island",
    code: "+47",
    lengths: 10,
  },
  bw: {
    country: "Botswana",
    code: "+267",
    lengths: 7,
  },
  by: {
    country: "Belarus",
    code: "+375",
    lengths: 9,
  },
  bz: {
    country: "Belize",
    code: "+501",
    lengths: 7,
  },
  ca: {
    country: "Canada",
    code: "+1",
    lengths: 10,
  },
  cc: {
    country: "Cocos (Keeling) Islands",
    code: "+61",
    lengths: 10,
  },
  cd: {
    country: "Congo, Democratic Republic of the",
    code: "+243",
    lengths: 7,
  },
  cf: {
    country: "Central African Republic",
    code: "+236",
    lengths: 8,
  },
  cg: {
    country: "Congo, Republic of the",
    code: "+242",
    lengths: 9,
  },
  ch: {
    country: "Switzerland",
    code: "+41",
    lengths: 9,
  },
  ci: {
    country: "Cote d'Ivoire",
    code: "+225",
    lengths: 8,
  },
  ck: {
    country: "Cook Islands",
    code: "+682",
    lengths: 5,
  },
  cl: {
    country: "Chile",
    code: "+56",
    lengths: 9,
  },
  cm: {
    country: "Cameroon",
    code: "+237",
    lengths: 9,
  },
  cn: {
    country: "China",
    code: "+86",
    lengths: 11,
  },
  co: {
    country: "Colombia",
    code: "+57",
    lengths: 10,
  },
  cr: {
    country: "Costa Rica",
    code: "+506",
    lengths: 8,
  },
  cu: {
    country: "Cuba",
    code: "+53",
    lengths: 8,
  },
  cv: {
    country: "Cape Verde",
    code: "+238",
    lengths: 7,
  },
  cw: {
    country: "Curacao",
    code: "+599",
    lengths: 7,
  },
  cx: {
    country: "Christmas Island",
    code: "+61",
    lengths: 9,
  },
  cy: {
    country: "Cyprus",
    code: "+357",
    lengths: 8,
  },
  cz: {
    country: "Czech Republic",
    code: "+420",
    lengths: 9,
  },
  de: {
    country: "Germany",
    code: "+49",
    lengths: 10,
  },
  dj: {
    country: "Djibouti",
    code: "+253",
    lengths: 10,
  },
  dk: {
    country: "Denmark",
    code: "+45",
    lengths: 8,
  },
  dm: {
    country: "Dominica",
    code: "+1767",
    lengths: 10,
  },
  do: {
    country: "Dominican Republic",
    code: "+1809",
    lengths: 10,
  },
  dz: {
    country: "Algeria",
    code: "+213",
    lengths: 9,
  },
  ec: {
    country: "Ecuador",
    code: "+593",
    lengths: 9,
  },
  ee: {
    country: "Estonia",
    code: "+372",
    lengths: 8,
  },
  eg: {
    country: "Egypt",
    code: "+20",
    lengths: 10,
  },
  eh: {
    country: "Western Sahara",
    code: "+212",
    lengths: 9,
  },
  er: {
    country: "Eritrea",
    code: "+291",
    lengths: 7,
  },
  es: {
    country: "Spain",
    code: "+34",
    lengths: 9,
  },
  et: {
    country: "Ethiopia",
    code: "+251",
    lengths: 9,
  },
  fi: {
    country: "Finland",
    code: "+358",
    lengths: [6, 9],
  },
  fj: {
    country: "Fiji",
    code: "+679",
    lengths: 7,
  },
  fk: {
    country: "Falkland Islands (Malvinas)",
    code: "+500",
    lengths: 5,
  },
  fm: {
    country: "Micronesia, Federated States of",
    code: "+691",
    lengths: 7,
  },
  fo: {
    country: "Faroe Islands",
    code: "+298",
    lengths: 5,
  },
  fr: {
    country: "France",
    code: "+33",
    lengths: 9,
  },
  ga: {
    country: "Gabon",
    code: "+241",
    lengths: 7,
  },
  gb: {
    country: "United Kingdom",
    code: "+44",
    lengths: 10,
  },
  gd: {
    country: "Grenada",
    code: "+1473",
    lengths: 10,
  },
  ge: {
    country: "Georgia",
    code: "+995",
    lengths: 9,
  },
  gf: {
    country: "French Guiana",
    code: "+594",
    lengths: 9,
  },
  gg: {
    country: "Guernsey",
    code: "+44",
    lengths: 10,
  },
  gh: {
    country: "Ghana",
    code: "+233",
    lengths: 9,
  },
  gi: {
    country: "Gibraltar",
    code: "+350",
    lengths: 8,
  },
  gl: {
    country: "Greenland",
    code: "+299",
    lengths: 6,
  },
  gm: {
    country: "Gambia",
    code: "+220",
    lengths: 7,
  },
  gn: {
    country: "Guinea",
    code: "+224",
    lengths: 9,
  },
  gp: {
    country: "Guadeloupe",
    code: "+590",
    lengths: 9,
  },
  gq: {
    country: "Equatorial Guinea",
    code: "+240",
    lengths: 9,
  },
  gr: {
    country: "Greece",
    code: "+30",
    lengths: 10,
  },
  gs: {
    country: "South Georgia and the South Sandwich Islands",
    code: "+500",
    lengths: 5,
  },
  gt: {
    country: "Guatemala",
    code: "+502",
    lengths: 8,
  },
  gu: {
    country: "Guam",
    code: "+1671",
    lengths: 10,
  },
  gw: {
    country: "Guinea-Bissau",
    code: "+245",
    lengths: 9,
  },
  gy: {
    country: "Guyana",
    code: "+592",
    lengths: 7,
  },
  hk: {
    country: "Hong Kong",
    code: "+852",
    lengths: 8,
  },
  hm: {
    country: "Heard Island and McDonald Islands",
    code: "+672",
    lengths: 10,
  },
  hn: {
    country: "Honduras",
    code: "+504",
    lengths: 8,
  },
  hr: {
    country: "Croatia",
    code: "+385",
    lengths: 9,
  },
  ht: {
    country: "Haiti",
    code: "+509",
    lengths: 8,
  },
  hu: {
    country: "Hungary",
    code: "+36",
    lengths: 9,
  },
  id: {
    country: "Indonesia",
    code: "+62",
    lengths: 11,
  },
  ie: {
    country: "Ireland",
    code: "+353",
    lengths: 9,
  },
  il: {
    country: "Israel",
    code: "+972",
    lengths: 9,
  },
  im: {
    country: "Isle of Man",
    code: "+44",
    lengths: 10,
  },
  in: {
    country: "India",
    code: "+91",
    lengths: 10,
  },
  io: {
    country: "British Indian Ocean Territory",
    code: "+246",
    lengths: 7,
  },
  iq: {
    country: "Iraq",
    code: "+964",
    lengths: 10,
  },
  ir: {
    country: "Iran, Islamic Republic of",
    code: "+98",
    lengths: 11,
  },
  is: {
    country: "Iceland",
    code: "+354",
    lengths: 7,
  },
  it: {
    country: "Italy",
    code: "+39",
    lengths: 10,
  },
  je: {
    country: "Jersey",
    code: "+44",
    lengths: 10,
  },
  jm: {
    country: "Jamaica",
    code: "+1876",
    lengths: 10,
  },
  jo: {
    country: "Jordan",
    code: "+962",
    lengths: [6, 7, 8, 9],
  },
  jp: {
    country: "Japan",
    code: "+81",
    lengths: [9, 10],
  },
  ke: {
    country: "Kenya",
    code: "+254",
    lengths: 10,
  },
  kg: {
    country: "Kyrgyzstan",
    code: "+996",
    lengths: 9,
  },
  kh: {
    country: "Cambodia",
    code: "+855",
    lengths: 9,
  },
  ki: {
    country: "Kiribati",
    code: "+686",
    lengths: 8,
  },
  km: {
    country: "Comoros",
    code: "+269",
    lengths: 7,
  },
  kn: {
    country: "Saint Kitts and Nevis",
    code: "+1869",
    lengths: 10,
  },
  kp: {
    country: "Korea, Democratic People's Republic of",
    code: "+850",
    lengths: [4, 6, 7, 13],
  },
  kr: {
    country: "Korea, Republic of",
    code: "+82",
    lengths: [7, 8],
  },
  kw: {
    country: "Kuwait",
    code: "+965",
    lengths: 8,
  },
  ky: {
    country: "Cayman Islands",
    code: "+1345",
    lengths: 7,
  },
  kz: {
    country: "Kazakhstan",
    code: "+7",
    lengths: 10,
  },
  la: {
    country: "Lao People's Democratic Republic",
    code: "+856",
    lengths: [8, 9],
  },
  lb: {
    country: "Lebanon",
    code: "+961",
    lengths: [7, 8],
  },
  lc: {
    country: "Saint Lucia",
    code: "+1758",
    lengths: 7,
  },
  li: {
    country: "Liechtenstein",
    code: "+423",
    lengths: 7,
  },
  lk: {
    country: "Sri Lanka",
    code: "+94",
    lengths: 7,
  },
  lr: {
    country: "Liberia",
    code: "+231",
    lengths: [8, 9],
  },
  ls: {
    country: "Lesotho",
    code: "+266",
    lengths: 8,
  },
  lt: {
    country: "Lithuania",
    code: "+370",
    lengths: 8,
  },
  lu: {
    country: "Luxembourg",
    code: "+352",
    lengths: 9,
  },
  lv: {
    country: "Latvia",
    code: "+371",
    lengths: 8,
  },
  ly: {
    country: "Libya",
    code: "+218",
    lengths: 10,
  },
  ma: {
    country: "Morocco",
    code: "+212",
    lengths: 9,
  },
  mc: {
    country: "Monaco",
    code: "+377",
    lengths: 8,
  },
  md: {
    country: "Moldova, Republic of",
    code: "+373",
    lengths: 8,
  },
  me: {
    country: "Montenegro",
    code: "+382",
    lengths: 8,
  },
  mf: {
    country: "Saint Martin (French part)",
    code: "+590",
    lengths: 6,
  },
  mg: {
    country: "Madagascar",
    code: "+261",
    lengths: 7,
  },
  mh: {
    country: "Marshall Islands",
    code: "+692",
    lengths: 7,
  },
  mk: {
    country: "Macedonia, the Former Yugoslav Republic of",
    code: "+389",
    lengths: 8,
  },
  ml: {
    country: "Mali",
    code: "+223",
    lengths: 8,
  },
  mm: {
    country: "Myanmar",
    code: "+95",
    lengths: 8,
  },
  mn: {
    country: "Mongolia",
    code: "+976",
    lengths: 8,
  },
  mo: {
    country: "Macao",
    code: "+853",
    lengths: 8,
  },
  mp: {
    country: "Northern Mariana Islands",
    code: "+1670",
    lengths: 7,
  },
  mq: {
    country: "Martinique",
    code: "+596",
    lengths: 9,
  },
  mr: {
    country: "Mauritania",
    code: "+222",
    lengths: 8,
  },
  ms: {
    country: "Montserrat",
    code: "+1664",
    lengths: 10,
  },
  mt: {
    country: "Malta",
    code: "+356",
    lengths: 8,
  },
  mu: {
    country: "Mauritius",
    code: "+230",
    lengths: 8,
  },
  mv: {
    country: "Maldives",
    code: "+960",
    lengths: 7,
  },
  mw: {
    country: "Malawi",
    code: "+265",
    lengths: [7, 8, 9],
  },
  mx: {
    country: "Mexico",
    code: "+52",
    lengths: 10,
  },
  my: {
    country: "Malaysia",
    code: "+60",
    lengths: 7,
  },
  mz: {
    country: "Mozambique",
    code: "+258",
    lengths: 12,
  },
  na: {
    country: "Namibia",
    code: "+264",
    lengths: 7,
  },
  nc: {
    country: "New Caledonia",
    code: "+687",
    lengths: 6,
  },
  ne: {
    country: "Niger",
    code: "+227",
    lengths: 8,
  },
  nf: {
    country: "Norfolk Island",
    code: "+672",
    lengths: 6,
  },
  ng: {
    country: "Nigeria",
    code: "+234",
    lengths: 8,
  },
  ni: {
    country: "Nicaragua",
    code: "+505",
    lengths: 8,
  },
  nl: {
    country: "Netherlands",
    code: "+31",
    lengths: 9,
  },
  no: {
    country: "Norway",
    code: "+47",
    lengths: 8,
  },
  np: {
    country: "Nepal",
    code: "+977",
    lengths: 10,
  },
  nr: {
    country: "Nauru",
    code: "+674",
    lengths: 7,
  },
  nu: {
    country: "Niue",
    code: "+683",
    lengths: 4,
  },
  nz: {
    country: "New Zealand",
    code: "+64",
    lengths: [8, 9],
  },
  om: {
    country: "Oman",
    code: "+968",
    lengths: 8,
  },
  pa: {
    country: "Panama",
    code: "+507",
    lengths: 8,
  },
  pe: {
    country: "Peru",
    code: "+51",
    lengths: 9,
  },
  pf: {
    country: "French Polynesia",
    code: "+689",
    lengths: 8,
  },
  pg: {
    country: "Papua New Guinea",
    code: "+675",
    lengths: 8,
  },
  ph: {
    country: "Philippines",
    code: "+63",
    lengths: 10,
  },
  pk: {
    country: "Pakistan",
    code: "+92",
    lengths: 10,
  },
  pl: {
    country: "Poland",
    code: "+48",
    lengths: 9,
  },
  pm: {
    country: "Saint Pierre and Miquelon",
    code: "+508",
    lengths: 6,
  },
  pn: {
    country: "Pitcairn",
    code: "+870",
    lengths: 9,
  },
  pr: {
    country: "Puerto Rico",
    code: "+1",
    lengths: 10,
  },
  ps: {
    country: "Palestine, State of",
    code: "+970",
    lengths: 9,
  },
  pt: {
    country: "Portugal",
    code: "+351",
    lengths: 9,
  },
  pw: {
    country: "Palau",
    code: "+680",
    lengths: 7,
  },
  py: {
    country: "Paraguay",
    code: "+595",
    lengths: 9,
  },
  qa: {
    country: "Qatar",
    code: "+974",
    lengths: 8,
  },
  re: {
    country: "Reunion",
    code: "+262",
    lengths: 10,
  },
  ro: {
    country: "Romania",
    code: "+40",
    lengths: 10,
  },
  rs: {
    country: "Serbia",
    code: "+381",
    lengths: 9,
  },
  ru: {
    country: "Russian Federation",
    code: "+7",
    lengths: 10,
  },
  rw: {
    country: "Rwanda",
    code: "+250",
    lengths: 9,
  },
  sa: {
    country: "Saudi Arabia",
    code: "+966",
    lengths: 9,
  },
  sb: {
    country: "Solomon Islands",
    code: "+677",
    lengths: 7,
  },
  sc: {
    country: "Seychelles",
    code: "+248",
    lengths: 7,
  },
  sd: {
    country: "Sudan",
    code: "+249",
    lengths: 7,
  },
  se: {
    country: "Sweden",
    code: "+46",
    lengths: 7,
  },
  sg: {
    country: "Singapore",
    code: "+65",
    lengths: 8,
  },
  sh: {
    country: "Saint Helena",
    code: "+290",
    lengths: 4,
  },
  si: {
    country: "Slovenia",
    code: "+386",
    lengths: 9,
  },
  sj: {
    country: "Svalbard and Jan Mayen",
    code: "+47",
    lengths: 8,
  },
  sk: {
    country: "Slovakia",
    code: "+421",
    lengths: 9,
  },
  sl: {
    country: "Sierra Leone",
    code: "+232",
    lengths: 8,
  },
  sm: {
    country: "San Marino",
    code: "+378",
    lengths: 10,
  },
  sn: {
    country: "Senegal",
    code: "+221",
    lengths: 9,
  },
  so: {
    country: "Somalia",
    code: "+252",
    lengths: [8, 9],
  },
  sr: {
    country: "Suriname",
    code: "+597",
    lengths: [6, 7],
  },
  ss: {
    country: "South Sudan",
    code: "+211",
    lengths: 7,
  },
  st: {
    country: "Sao Tome and Principe",
    code: "+239",
    lengths: 7,
  },
  sv: {
    country: "El Salvador",
    code: "+503",
    lengths: 8,
  },
  sx: {
    country: "Sint Maarten (Dutch part)",
    code: "+1721",
    lengths: 10,
  },
  sy: {
    country: "Syrian Arab Republic",
    code: "+963",
    lengths: 7,
  },
  sz: {
    country: "Swaziland",
    code: "+268",
    lengths: 8,
  },
  tc: {
    country: "Turks and Caicos Islands",
    code: "+1649",
    lengths: 10,
  },
  td: {
    country: "Chad",
    code: "+235",
    lengths: 6,
  },
  tf: {
    country: "French Southern Territories",
    code: "+262",
    lengths: 10,
  },
  tg: {
    country: "Togo",
    code: "+228",
    lengths: 8,
  },
  th: {
    country: "Thailand",
    code: "+66",
    lengths: 9,
  },
  tj: {
    country: "Tajikistan",
    code: "+992",
    lengths: 9,
  },
  tk: {
    country: "Tokelau",
    code: "+690",
    lengths: 5,
  },
  tl: {
    country: "Timor-Leste",
    code: "+670",
    lengths: 7,
  },
  tm: {
    country: "Turkmenistan",
    code: "+993",
    lengths: 8,
  },
  tn: {
    country: "Tunisia",
    code: "+216",
    lengths: 8,
  },
  to: {
    country: "Tonga",
    code: "+676",
    lengths: 5,
  },
  tr: {
    country: "Turkey",
    code: "+90",
    lengths: 11,
  },
  tt: {
    country: "Trinidad and Tobago",
    code: "+1868",
    lengths: 7,
  },
  tv: {
    country: "Tuvalu",
    code: "+688",
    lengths: 5,
  },
  tw: {
    country: "Taiwan, Province of China",
    code: "+886",
    lengths: 9,
  },
  tz: {
    country: "United Republic of Tanzania",
    code: "+255",
    lengths: 7,
  },
  ua: {
    country: "Ukraine",
    code: "+380",
    lengths: 9,
  },
  ug: {
    country: "Uganda",
    code: "+256",
    lengths: 7,
  },
  us: {
    country: "United States",
    code: "+1",
    lengths: 10,
  },
  uy: {
    country: "Uruguay",
    code: "+598",
    lengths: 8,
  },
  uz: {
    country: "Uzbekistan",
    code: "+998",
    lengths: 9,
  },
  va: {
    country: "Holy See (Vatican City State)",
    code: "+379",
    lengths: 10,
  },
  vc: {
    country: "Saint Vincent and the Grenadines",
    code: "+1784",
    lengths: 7,
  },
  ve: {
    country: "Venezuela",
    code: "+58",
    lengths: 7,
  },
  vg: {
    country: "British Virgin Islands",
    code: "+1284",
    lengths: 7,
  },
  vi: {
    country: "US Virgin Islands",
    code: "+1340",
    lengths: 10,
  },
  vn: {
    country: "Vietnam",
    code: "+84",
    lengths: 9,
  },
  vu: {
    country: "Vanuatu",
    code: "+678",
    lengths: 5,
  },
  wf: {
    country: "Wallis and Futuna",
    code: "+681",
    lengths: 6,
  },
  ws: {
    country: "Samoa",
    code: "+685",
    lengths: [5, 6, 7],
  },
  xk: {
    country: "Kosovo",
    code: "+383",
    lengths: 8,
  },
  ye: {
    country: "Yemen",
    code: "+967",
    lengths: 9,
  },
  yt: {
    country: "Mayotte",
    code: "+262",
    lengths: 9,
  },
  za: {
    country: "South Africa",
    code: "+27",
    lengths: 9,
  },
  zm: {
    country: "Zambia",
    code: "+260",
    lengths: 9,
  },
  zw: {
    country: "Zimbabwe",
    code: "+263",
    lengths: 9,
  },
};
